import Aos from "aos";
import React, { useEffect } from "react";

const Heading = ({ headingText, className = "" }) => {
  return (
    <h1
      className={`text-transparent bg-clip-text bg-text-gradient text-[11vw] md:text-[5.5vw] flex flex-wrap text-center tracking-normal font-bebas_neue uppercase  ${className}`}
      // data-aos="fade-up"
    >
      {headingText}
    </h1>
  );
};

export default Heading;
